import {
	addressCityAtom,
	addressCountryAtom,
	addressStateAtom,
	addressStreetAtom,
} from 'features/generator/contentFormSections/LocationForm/addressAtoms'
import { useAtomValue } from 'jotai'

export const useFullLocationUrl = () => {
	const street = useAtomValue(addressStreetAtom)
	const city = useAtomValue(addressCityAtom)
	const state = useAtomValue(addressStateAtom)
	const country = useAtomValue(addressCountryAtom)

	const addressParam = [street, city, state, country]
		.filter((value) => value?.length)
		.join(',+')

	return `https://www.google.com/maps/place/${addressParam}`
}
